<template>
  <div class="py-5 md:px-5">
    <PageHeader title="Settings" class="container mb-4" />

    <div class="container">
      <div class="space-y-6 md:space-y-0 md:grid-cols-4 md:gap-6 md:grid">
        <div class="col-span-1">
          <nav class="space-y-1" aria-label="Sidebar">
            <router-link v-for="link in allowedLinks" :key="link.route" :to="{ name: link.route }" class="flex items-center px-3 py-3 text-sm font-medium text-gray-600 rounded-md hover:no-underline hover:bg-white hover:text-gray-900" active-class="text-gray-900 bg-gray-100 hover:bg-gray-100" aria-current="page">
              <fa :icon="['far', link.icon]" class="mr-3 text-lg opacity-75" fixed-width />
              <span class="truncate">
                {{ link.name }}
              </span>
            </router-link>
          </nav>
        </div>
        <div class="col-span-3">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsView',
  
  computed: {
    ...mapGetters(['account']),

    allowedLinks () {
      let links = []

      if (this.account.permissions.account || this.account.role !== 'user') {
        links.push({
          name: 'Company',
          icon: 'building',
          route: 'SettingsCompany'
        },
        {
          name: 'Security',
          icon: 'lock-alt',
          route: 'SettingsSecurity'
        },
        {
          name: 'Integrations',
          icon: 'plug',
          route: 'SettingsIntegrations'
        },
        {
          name: 'Taxes',
          icon: 'percent',
          route: 'SettingsTaxes'
        })
      }

      if (this.account.permissions.billing || this.account.role !== 'user') {
        links.push({
          name: 'Billing & Plan',
          icon: 'credit-card',
          route: 'SettingsBilling'
        })
      }

      if (this.account.permissions.users || this.account.role !== 'user') {
        links.push({
          name: 'Users',
          icon: 'users',
          route: 'SettingsUsers'
        })
      }

      return links
    }
  }
}
</script>